import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { Select as BackstageSelect } from '@backstage/core-components';
import { CatalogTable } from '@backstage/plugin-catalog';
import {
  EntityKindPicker,
  EntityTypePicker,
  EntityOwnerPicker,
  EntityLifecyclePicker,
  EntityTagPicker,
  EntityNamespacePicker,
  EntityProcessingStatusPicker,
  useEntityList,
  EntityUserFilter,
  useStarredEntities,
} from '@backstage/plugin-catalog-react';

const useStyles = makeStyles(theme => ({
  filterBar: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    gap: theme.spacing(1.5),
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    background: theme.palette.background.paper,
    borderRadius: 12,
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
    border: '1px solid rgba(0,0,0,0.07)',
    '& > *': {
      flex: '1 1 120px',
      minWidth: 110,
      maxWidth: 180,
      [theme.breakpoints.down('sm')]: {
        flex: '1 1 45%',
        maxWidth: '48%',
      },
      [theme.breakpoints.down('xs')]: {
        flex: '1 1 100%',
        maxWidth: '100%',
      },
    },
  },
}));

const UserFilterPicker = () => {
  const { filters, updateFilters } = useEntityList();
  const { starredEntities } = useStarredEntities();
  const currentValue = (filters.user as EntityUserFilter | undefined)?.value ?? 'all';

  function handleChange(value: string) {
    if (value === 'owned') {
      updateFilters({ user: EntityUserFilter.owned([]) });
    } else if (value === 'starred') {
      updateFilters({ user: EntityUserFilter.starred([...starredEntities]) });
    } else {
      updateFilters({ user: EntityUserFilter.all() });
    }
  }

  return (
    <Box pb={1} pt={1}>
      <BackstageSelect
        label="My Items"
        selected={currentValue}
        items={[
          { label: 'All', value: 'all' },
          { label: 'Owned', value: 'owned' },
          { label: 'Starred', value: 'starred' },
        ]}
        onChange={value => handleChange(String(value))}
      />
    </Box>
  );
};

export const CatalogContent = () => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.filterBar}>
        <EntityKindPicker />
        <EntityTypePicker />
        <UserFilterPicker />
        <EntityOwnerPicker />
        <EntityLifecyclePicker />
        <EntityTagPicker />
        <EntityProcessingStatusPicker />
        <EntityNamespacePicker />
      </div>
      <CatalogTable />
    </>
  );
};
